import React, { useEffect, useRef, useState } from 'react';

// ─── Assumption flagged (still unconfirmed) ──────────────────────────
import googleBanner from '../../../assets/images/banners/google_banner.jpeg';
import socialMediaBanner from '../../../assets/images/banners/social_media_management.jpeg';

const ROTATE_INTERVAL_MS = 60000;
const SCROLL_MS = 700;
const BANNER_ASPECT_RATIO = '930 / 180';

const BANNERS = [
  {
    image: googleBanner,
    alt: 'Get Google Workspace 10% off',
    link: 'https://referworkspace.app.goo.gl/NVn8',
  },
  {
    image: socialMediaBanner,
    alt: 'Social Media Management - $1/day',
    link: 'https://www.mycouponbook.ca/blogs/nelson-bowman/90-for-90-days-social-media-management-deal',
  },
];

const FeatureBanner = () => {
  const [index, setIndex] = useState(0);
  const [scrolling, setScrolling] = useState(false);
  const rotateRef = useRef(null);

  const nextIndex = (index + 1) % BANNERS.length;
  const current = BANNERS[index];
  const upNext = BANNERS[nextIndex];

  useEffect(() => {
    if (BANNERS.length < 2) return undefined;

    rotateRef.current = setInterval(() => {
      setScrolling(true); // kicks off the slide-up transition
    }, ROTATE_INTERVAL_MS);

    return () => clearInterval(rotateRef.current);
  }, []);

  // Fires when the slide-up transform finishes: swap to the next banner
  // and snap the track back to rest in the same tick (transition: none
  // on that render), so there's no visible jump.
  const handleTransitionEnd = () => {
    if (!scrolling) return;
    setIndex(nextIndex);
    setScrolling(false);
  };

  const handleClick = () => {
    window.open(current.link, '_blank', 'noopener,noreferrer');
  };

  if (!current) return null;

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
      style={{
        borderRadius: 14,
        overflow: 'hidden',
        cursor: 'pointer',
        width: '100%',
        aspectRatio: BANNER_ASPECT_RATIO,
        marginBottom: 20,
        flexShrink: 0,
        position: 'relative',
      }}
    >
      {/* Track holds current + upcoming banner stacked vertically at
          200% height; sliding it up by 50% of its own height moves
          exactly one banner's worth — like a billboard flipping. */}
      <div
        onTransitionEnd={handleTransitionEnd}
        style={{
          height: '200%',
          transform: scrolling ? 'translateY(-50%)' : 'translateY(0)',
          transition: scrolling ? `transform ${SCROLL_MS}ms cubic-bezier(.4,0,.2,1)` : 'none',
        }}
      >
        <img
          src={current.image}
          alt={current.alt}
          style={{ width: '100%', height: '50%', objectFit: 'cover', display: 'block' }}
        />
        <img
          src={upNext.image}
          alt={upNext.alt}
          style={{ width: '100%', height: '50%', objectFit: 'cover', display: 'block' }}
        />
      </div>
    </div>
  );
};

export default FeatureBanner;